var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTonFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h60v45H0V0Z",
    fill: "#C10000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h23.438v18.778H0V0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.638 2.925h3.74v13.087h-3.73l-.01-13.087Z",
    fill: "#C10000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.056 7.594v3.75H4.97v-3.75h13.087Z",
    fill: "#C10000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h60v45H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTonFlag);
export default __webpack_public_path__ + "static/media/ton-flag.06a6827f1eda49bbf2485b8df0c553fd.svg";
export { ForwardRef as ReactComponent };